// import React from 'react'

export default function Header({ stats }) {
  const {
    totalMovies = 0,
    totalViews = 0,
    totalEarnings = 0.00,
  } = stats || {}

  return (
    <div className="w-full bg-white p-4 md:p-6 rounded-xl shadow-sm mb-8">
      <h1 className="text-xl md:text-2xl font-bold mb-6">Statistics</h1>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
       
        <div className="bg-white border border-gray-200 shadow-sm rounded-lg p-4 flex flex-col justify-center">
          <span className="text-sm text-gray-500">Total Movies</span>
          <h2 className="text-2xl font-semibold mt-1">{totalMovies}</h2>
        </div>

        <div className="bg-white border border-gray-200 shadow-sm rounded-lg p-4 flex flex-col justify-center">
          <span className="text-sm text-gray-500">Total Views</span>
          <h2 className="text-2xl font-semibold mt-1">{totalViews}</h2>
        </div>

        <div className="bg-white border border-gray-200 shadow-sm rounded-lg p-4 flex flex-col justify-center">
          <span className="text-sm text-gray-500">Total Earnings</span>
          <h2 className="text-2xl font-semibold mt-1">₦{totalEarnings.toFixed(2)}</h2>
        </div>
      </div>
      
    </div>
  )
}
